var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressReportOliGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 124,
    viewBox: "0 0 86 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 82.2385C54.4504 87.868 87.4864 61.9638 79.8857 15.1539C70.3847 -43.3585 67.0615 86.7592 34 82.2385Z",
    fill: "#61A474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0015 84.5004C54.8957 91.495 87.551 94.0356 83.4614 79.1036C78.3495 60.4386 67.5022 94.5451 35.0015 84.5004Z",
    fill: "#61A474"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0046 85.9993C50.7505 102.023 76.8723 122.89 80.8101 107.888C85.7324 89.135 60.1538 110.978 37.0046 85.9993Z",
    fill: "#61A474"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9939 60.9988C23.4419 58.6399 28.4144 57.5504 33.362 57.8505C38.3372 58.1523 49.1153 59.8009 44.9497 65.5903C42.8324 68.5331 40.7233 67.611 38.0644 66.4487C36.5149 65.7713 34.7788 65.0123 32.7456 64.889C29.0806 64.6667 25.3972 65.4737 22.1024 67.2211C18.8076 68.9685 16.0297 71.588 14.0757 74.7904C12.1216 77.9927 11.1094 81.6534 11.0716 85.3674L4.10187 85.3674C4.15282 80.3536 5.51995 75.5403 8.15792 71.2172C10.7959 66.8941 14.546 63.3577 18.9939 60.9988Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9939 109.691C23.4419 112.05 28.4144 113.139 33.362 112.839C38.3372 112.537 49.1153 110.889 44.9497 105.099C42.8324 102.156 40.7233 103.078 38.0644 104.241C36.5149 104.918 34.7788 105.677 32.7456 105.8C29.0806 106.023 25.3972 105.216 22.1024 103.468C18.8076 101.721 16.0297 99.1014 14.0757 95.8991C12.1216 92.6968 11.1094 89.036 11.0716 85.3221L4.10187 85.3221C4.15282 90.3359 5.51995 95.1492 8.15792 99.4723C10.7959 103.795 14.546 107.332 18.9939 109.691Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4615 87.0745C25.2609 86.025 25.7684 84.4951 25.7766 82.7895C25.7919 79.6127 24.0695 77.029 21.9295 77.0187C19.7895 77.0084 18.0423 79.5753 18.027 82.7521C18.0187 84.4578 18.5115 85.9924 19.3008 87.0496C20.032 86.201 22.088 85.0178 24.4615 87.0745Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6391 87.138C38.4642 86.0886 38.9879 84.5588 38.9961 82.8532C39.0114 79.6764 37.2329 77.0924 35.0236 77.0818C32.8144 77.0711 31.011 79.6378 30.9957 82.8146C30.9875 84.5203 31.4964 86.055 32.3114 87.1123C33.0662 86.2638 35.1885 85.081 37.6391 87.138Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressReportOliGreen);
export default __webpack_public_path__ + "static/media/Progress Report - Oli (Green).e3dc09a2b096bd1918fc736ad7f951a0.svg";
export { ForwardRef as ReactComponent };